// extracted by mini-css-extract-plugin
export var copyableItem = "_g-0";
export var underlined = "_g-1";